import styled from 'styled-components';
import { body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const CampaignSelectorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.half};
    align-self: stretch;
    padding-top: ${pxToRem(16)};
    
    ${body2};
    color: ${colors.textSecondary};

    > div {
        width: 100%;
    }
`;

export const CampaignSelectorHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: baseline;
    align-self: stretch;
    gap: ${spacing.half};
`;
